import $axios from "../../api/axios";

function getLstApi({ params, callback }) {
  $axios
    .post(`/api/housePropertyList/${params}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getLstApi
};



// WEBPACK FOOTER //
// ./src/api/account/recommend.js